module.exports = __webpack_public_path__ + "static/img/yw.877ad7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/yw.png
// module id = esj6
// module chunks = 1